import { render, staticRenderFns } from "./nocity.vue?vue&type=template&id=3490e1ee&scoped=true&"
import script from "./nocity.vue?vue&type=script&lang=js&"
export * from "./nocity.vue?vue&type=script&lang=js&"
import style0 from "./nocity.vue?vue&type=style&index=0&id=3490e1ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490e1ee",
  null
  
)

export default component.exports